export interface DealStatusOption {
    value: string;
    label: string;
    group: string;
}

export const dealStatusOptions: DealStatusOption[] = [
    {
        value: 'appInProgress',
        label: 'App In Progress',
        group: 'Application',
    },
    {
        value: 'appComplete',
        label: 'App Complete',
        group: 'Application',
    },
    {
        value: 'awaitingLender',
        label: 'Awaiting Lender',
        group: 'Underwriting',
    },
    {
        value: 'pendingFundingManager',
        label: 'Pending Funding Manager',
        group: 'Underwriting',
    },
    {
        value: 'declined',
        label: 'Declined',
        group: 'Underwriting',
    },
    {
        value: 'offerReceived',
        label: 'Offer Received',
        group: 'Underwriting',
    },
    {
        value: 'offerToBorrower',
        label: 'Offer To Borrower',
        group: 'Underwriting'
    },
    {
        value: 'offerAccepted',
        label: 'Offer Accepted',
        group: 'Underwriting'
    },
    {
        value: 'offerDeclined',
        label: 'Offer Declined',
        group: 'Underwriting'
    },
    {
        value: 'contractRequested',
        label: 'Contract Requested',
        group: 'Closing'
    },
  {
    value: 'contractIn',
    label: 'Contract In',
    group: 'Closing',
  },
    {
        value: 'contractOut',
        label: 'Contract Out',
        group: 'Closing'
    },
    {
        value: 'funding',
        label: 'Funding',
        group: 'Closing'
    },
    {
        value: 'current',
        label: 'Current',
        group: 'Funded'
    },
    {
        value: 'renewed',
        label: 'Renewed',
        group: 'Funded'
    },
    {
        value: 'behind',
        label: 'Behind',
        group: 'Funded'
    },
    {
        value: 'default',
        label: 'Default',
        group: 'Funded'
    },
    {
        value: 'paidOff',
        label: 'Paid Off',
        group: 'Funded'
    },
    {
        value: 'stacked',
        label: 'Stacked',
        group: 'Funded'
    },
    {
        value: 'lostDeal',
        label: 'Lost Deal',
        group: 'Inactive'
    },
    {
        value: 'lostContact',
        label: 'Lost Contact',
        group: 'Inactive'
    },
    {
        value: 'doesNotQualify',
        label: 'Does Not Qualify',
        group: 'Inactive'
    },
    {
        value: 'dead',
        label: 'Dead',
        group: 'Inactive'
    }
];
